
function validateRacePlayerInput(racePlayers) {
  let valid = true;
  let messages = [];
  let playerIds = [];
  let characterIds = [];
  let places = [];

  // validate uniqueness
  for (var i = 0; i < racePlayers.length; i++) {
    if (racePlayers[i].playerId !== "" && playerIds.includes(racePlayers[i].playerId)) {
      messages.push("Duplicate players detected.");
      valid = false;
    }
    if (racePlayers[i].characterId !== "" && characterIds.includes(racePlayers[i].characterId)) {
      messages.push("Duplicate characters detected.");
      valid = false;
    }
    if (racePlayers[i].place !== "" && places.includes(racePlayers[i].place)) {
      messages.push("Duplicate places detected.");
      valid = false;
    }

    // add new info to arrays
    playerIds.push(racePlayers[i].playerId);
    characterIds.push(racePlayers[i].characterId);
    places.push(racePlayers[i].place);
  }

  // ensure all places present
  for (let i = 1; i <= racePlayers.length; i++) {
    if (!places.includes(i)) {
      messages.push("Missing place ".concat(i, "."));
      valid = false;
    }
  }

  // ensure no missing data or empty rows
  for (let i = 0; i < playerIds.length; i++) {
    if (!playerIds[i] || playerIds[i].length === 0) {
      messages.push("Unlabeled player detected.");
      valid = false;
    }
  }

  for (let i = 0; i < characterIds.length; i++) {
    if (!characterIds[i] || characterIds[i].length === 0) {
      messages.push("Unlabeled character detected.");
      valid = false;
    }
  }

  for (let i = 0; i < places.length; i++) {
    if (places[i] === null || places[i] === undefined || places[i] === "") {
      messages.push("Unlabeled place detected.");
      valid = false;
    }
  }

  return {
    "valid": valid,
    "messages": messages
  }
}

function validateRaceInput(race) {
  let valid = true;
  let messages = [];

  if (parseInt(race['ccId']) < 1 || parseInt(race['ccId'] > 4)) {
    messages.push("Invalid CC value.");
    valid = false;
  }
  if (parseInt(race['courseId']) < 1 || parseInt(race['courseId']) > 16) {
    messages.push("Invalid courseId value.");
    valid = false;
  }
  if (race['grandPrixId'].slice(0, 4) !== "gpx-" && !["0", "1"].includes(race['grandPrixId'])) {
    messages.push("Invalid grandPrixId value.");
    valid = false;
  }
  if (parseInt(race['systemId']) < 1 || parseInt(race['systemId']) > 9) {
    messages.push("Invalid systemId value.");
    valid = false;
  }
  if (race['onlineRace'] < 0 || race['onlineRace'] > 1) {
    messages.push("Invalid onlineRace value.");
    valid = false;
  }

  return {
    "valid": valid,
    "messages": messages
  }
}

function validateFullRaceInput(race) {
  let valid = true;
  let messages = [];

  let racePlayerVal = validateRacePlayerInput(race.racePlayers);
  let raceVal = validateRaceInput(race);

  if (!racePlayerVal['valid'] || !raceVal['valid']) { valid = false; }

  messages = raceVal['messages'].concat(racePlayerVal['messages']);

  return { "valid": valid, "messages": messages };
}


function validateGrandPrixInput(grandPrix) {
  let valid = true;
  let messages = [];

  // if (grandPrix['grandPrixId'].slice(0, 4) !== "gpx-" && !["0", "1"].includes(grandPrix['grandPrixId'])) {
  //     messages.push("Invalid grandPrixId value.");
  //     valid = false;
  // }
  if (grandPrix['title'].includes("/") || grandPrix['title'].includes("@")) {
    messages.push("Invalid title value. Not allowed: ['/', '@']");
    valid = false;
  }
  if (grandPrix['ruleId'] < 0 || grandPrix['ruleId'] > 4) {
    messages.push("Invalid ruleId value.");
    valid = false;
  }
  if (![0, 1].includes(grandPrix['hardcore'])) {
    messages.push("Invalid hardcore value.");
    valid = false;
  }
  if (![2, 3, 4].includes(grandPrix['groupSize'])) {
    messages.push("Invalid group size value.");
    valid = false;
  }
  if (grandPrix["grandPrixId"] === "0" && grandPrix["hardcore"] === 1) {
    messages.push("Invalid grand prix id (0) and hardcore (1) combination.");
    valid = false;
  }
  if (grandPrix["grandPrixId"] === "1" && grandPrix["hardcore"] === 0) {
    messages.push("Invalid grand prix id (1) and hardcore (0) combination.");
    valid = false;
  }
  if (parseInt(grandPrix['ccId']) < 1 || parseInt(grandPrix['ccId'] > 4)) {
    messages.push("Invalid CC value.");
    valid = false;
  }

  return { "valid": valid, "messages": messages };
}

function validateStaticRaceInput(staticRaceInput) {
  let valid = true;
  let messages = [];

  if (staticRaceInput['userId'] === undefined) {
    messages.push("Invalid user id value.");
    valid = false;
  }
  // if (staticRaceInput["gameId"] != "2") { // must be Mario Kart 64
  //     messages.push("Invalid game id value.");
  //     valid = false;
  // }
  if (!["2", "9"].includes(staticRaceInput['systemId'])) {
    messages.push("Invalid game id value.");
    valid = false;
  }
  if (![0, 1].includes(staticRaceInput['onlineRace'])) {
    messages.push("Invalid online race value.");
    valid = false;
  }

  return { "valid": valid, "messages": messages };
}

module.exports = {
  validateRacePlayerInput,
  validateRaceInput,
  validateFullRaceInput,
  validateGrandPrixInput,
  validateStaticRaceInput
};
